export const WidgetDocumentTrackerStates = {
    OnTime: 'OnTime',
    Warning: 'Warning',
    Expired: 'Expired'
};